import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';

document.addEventListener('DOMContentLoaded', () => {
	/* Only scroll on mobile; above the mobile breakpoint the badges are a static row */
	const mq = window.matchMedia('(max-width: 768px)');

	/* Initialise every instance separately, as the same slider can appear more than once on a page */
	for (const element of document.querySelectorAll('.swiper.g2-badges-slider')) {
		const wrapper = element.querySelector('.swiper-wrapper');
		const baseHtml = wrapper.innerHTML;
		let swiper = null;

		const activate = () => {
			if (swiper) {
				return;
			}

			/* Only five badges exist in the markup, which is too few for Swiper to build a
			   smooth, gap-free loop. Duplicate them so there are always plenty of slides.
			   Snapshot the children first: wrapper.children is a live collection, so
			   iterating it while appending clones would loop forever. */
			for (const slide of Array.from(wrapper.children)) {
				const clone = slide.cloneNode(true);
				clone.setAttribute('aria-hidden', 'true');
				clone.querySelector('img')?.removeAttribute('alt');
				wrapper.append(clone);
			}

			swiper = new Swiper(element, {
				modules: [Autoplay],
				slidesPerView: 'auto',
				spaceBetween: 6,
				loop: true,
				speed: 4000,
				allowTouchMove: false,
				autoplay: {
					delay: 0,
					disableOnInteraction: false,
				},
			});
		};

		const deactivate = () => {
			if (!swiper) {
				return;
			}

			swiper.destroy(true, true);
			swiper = null;
			wrapper.innerHTML = baseHtml;
		};

		if (mq.matches) {
			activate();
		}

		mq.addEventListener('change', event => {
			if (event.matches) {
				activate();
			} else {
				deactivate();
			}
		});
	}
});
